<template>
  <Modal
    class="my-modal withdrawal-modal top"
    v-model="visible"
    :transfer="false"
    :footer-hide="true"
    :closable="false"
    width="500"
  >
    <Form ref="form" :model="form" :label-width="130" class="modal-form" v-if="visible">
      <FormItem prop="mobile" label="银行预留手机号" :rules="$units.formRule.tel()">
        <Input v-model="form.mobile" placeholder="请输入" maxlength="11" />
      </FormItem>

      <FormItem prop="code" label="手机验证码" :rules="$units.formRule.required('请输入验证码')">
        <Input v-model="form.code" placeholder="请输入" maxlength="10" class="code-input" />
        <Button class="btn" type="primary" @click="getCodeAjax" v-if="codeIndex == CODE_SIZE">获取验证码</Button>
        <Button class="btn" type="primary" v-else>{{ codeIndex }}S</Button>
      </FormItem>
    </Form>

    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="ok" :loading="loading">确定</Button>
    </div>
  </Modal>
</template>

<script>
import { codeTools } from '@/api/mixins';
export default {
  mixins: [codeTools],
  data() {
    return {
      visible: false,
      loading: false,
      form: {}
    };
  },
  methods: {
    async open(mobile, cardNo) {
      this.visible = true;
      this.$set(this.form, 'cardNo', cardNo);
      this.$set(this.form, 'mobile', mobile);
      this.$set(this.form, 'code', '');
      this.$notice.showLoading();
      this.$notice.hideLoading();
      this.clearCodeTimer();
    },

    getCodeAjax() {
      var regExp = /^1[1023456789]\d{9}$/;
      if (!regExp.test(this.form.mobile)) {
        this.$notice.msg('请输入正确的手机号');
        return;
      }
      this.timerStart();
      this.$http({
        type: 'GET',
        url: '/buz/userBase/sendCode',
        data: {
          mobile: this.form.mobile
        }
      })
        .then(res => {})
        .catch(e => {
          window.clearInterval(this.timer);
          this.codeIndex = CODE_SIZE;
        });
    },

    ok() {
      this.$refs.form.validate().then(async isok => {
        if (!isok) {
          return;
        }
        var regExp = /^1[1023456789]\d{9}$/;
        if (!regExp.test(this.form.mobile)) {
          this.$notice.msg('请输入正确的手机号');
          return;
        }
        this.loading = true;
        this.$http({
          type: 'POST',
          url: '/buz/userBase/updateUserCardPhone',
          data: {
            reservedMobile: this.form.mobile,
            code: this.form.code,
            cardNo: this.form.cardNo
          }
        })
          .then(res => {
            this.loading = false;
            this.visible = false;
            this.$emit('getUserNewMobile', this.form.mobile);
          })
          .catch(e => {
            this.loading = false;
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.code-input {
  width: 200px;
  margin-right: 22px;
}
.btn {
  width: 87px;
}
</style>
